// src/components/Assets/Templates/Normal1/normal1.js
export default `
 <!DOCTYPE HTML>
<!DOCTYPE html PUBLIC "" ""><html lang="en" dir="ltr" xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:v="urn:schemas-microsoft-com:vml"><head> 
<meta charset="utf-8"> 
<meta content="IE=edge" http-equiv="X-UA-Compatible"> 
<meta content="width=device-width,initial-scale=1" name="viewport"> 
<meta content="telephone=no, date=no, address=no, email=no, url=no" name="format-detection"> 
<meta name="x-apple-disable-message-reformatting"> 
<meta content="light dark" name="color-scheme"> 
<meta content="light dark" name="supported-color-schemes">
<title>Srihari Muppalla</title>
<!--[if mso]>
<noscript>
<xml>
<o:OfficeDocumentSettings>
<o:PixelsPerInch>96</o:PixelsPerInch>
</o:OfficeDocumentSettings>
</xml>
</noscript>
<style>
table { border-collapse: collapse; mso-table-lspace: 0px; mso-table-rspace: 0px; }
sup { font-size:100%;line-height:100%;mso-text-raise: 4px;}
li {margin-left:-23px !important}
.nostyle{list-style: none !important}
.ot4{padding-top: 4px !important;}
</style>
<![endif]--> 
<style>
:root {
color-scheme: light dark;
supported-color-schemes: light dark;
}
/* Fix for Outlook links color fix for links and visited links */
span.MsoHyperlink {color: inherit !important;mso-style-priority: 99 !important;text-decoration: underline !important;}

span.MsoHyperlinkFollowed {color: inherit !important;mso-style-priority: 99 !important;text-decoration: underline !important;}
/* normalise link attributes in Outlook app iOS/Android - to match the parent element */
body[data-outlook-cycle] a {color: inherit !important;text-decoration: none !important;}
/* normalise link attributes in Apple Mail / iOS Mail apps - to match the parent element */
a[x-apple-data-detectors] {color: inherit!important;text-decoration: none!important;font-size: inherit!important;font-family: inherit!important;font-weight: inherit!important;line-height: inherit!important;}
#root [x-apple-data-detectors=true],a[x-apple-data-detectors=true]{
color: inherit !important;text-decoration: inherit !important;}
#main #inner a[x-apple-data-detectors]{color: inherit !important;
text-decoration: inherit !important;}
a[href^=tel], #MessageViewBody a, a[x-apple-data-detectors], #body a, .link {color: inherit;text-decoration: none;font-size: inherit;
font-family: inherit;font-weight: inherit;line-height: inherit;}
[data-outlook-cycle] [x-apple-data-detectors-type="calendar-event"] {color: inherit !important;-webkit-text-decoration-color: inherit !important;text-decoration: none !important;}
/* normalise link attributes in Gmail - to match the parent element */
u + #body a {color: inherit;text-decoration: none;font-size: inherit;font-weight: inherit;line-height: inherit;}
#preheader,#preview-spacer {display: none;display:none!important;}
.applelink a{color: #000000 !important; text-decoration: none !important;}
ul {padding-left: 17px !important;}
ol {padding-left: 17px !important;}
hr{margin: 0 !important;}
.faux-absolute{max-height:0;position:relative;opacity:0.999;}
.hide{display: none;}
/*Mobile CSS*/
@media only screen and (min-width: 180px),screen and (max-width: 200px) { .bg{background-color: red !important;} }
@media only screen and (max-width: 480px){
.mt20{margin-top: 20px !important;}
.malr30{margin-left: 15px !important; margin-right: 28px !important;}
.pb16{padding-bottom: 16px !important;}
.mt22{margin-top: 22px !important;}
.mt36{margin-top: 36px !important;}
.mright{margin-right: 0px !important;}
.w30{width:30px !important;}
.lhight{line-height: 22px !important;}
.pt11{padding-top: 11px !important;}
.mb19{margin-bottom: 18px !important;}
.font13{font-size: 13px !important; line-height: 17px !important;}
.mb4{margin-bottom: 4px !important;}
.pb3{padding-bottom: 3px !important;}
.pb4{padding-bottom: 7px !important;}
.mb8{margin-bottom: 8px !important;}
.mt12{margin-top: 12px !important;}
.font16{font-size: 16px !important; line-height: 20px !important;}
.pt117{padding-top: 245px !important;}
.mt6{margin-top: 6px !important;}
.mb7{margin-bottom: 7px !important;}
.w240{width:312px !important;}
.pr15{padding-right: 30px !important;}
.pl15{padding-left: 30px !important;}
.mlr12{margin-left: 12px !important; margin-right: 12px !important;}
.w290{width:290px !important;}
.pb14{padding-bottom: 14px !important;}
.mt15{margin-top: 11px !important;}
.pt10{padding-top: 12px !important;}
.pb10{padding-bottom: 12px !important;}
.pb12{padding-bottom: 19px !important;}
.mlr15{margin-left: 15px !important; margin-right: 15px !important;}
.plr15{padding-left: 15px !important; padding-right: 15px !important;}
.w230{width:230px !important;}
.mr5{margin-right: 5px !important;}
.w12{width:12px !important;}
.ml12{margin-left: 12px !important;}
.mb37{margin-bottom: 37px !important;}
.w15{width:15px !important;}
.ml13{margin-left: 13px !important;}
.mr17{margin-right: 12px !important;}
.w17a{width:17px !important;}
.ml17{margin-left: 17px !important;}
.mt10a{margin-top: 9px !important;}
.mb25{margin-bottom: 25px !important;}
.tleft{text-align: left !important;}
.mb7{margin-bottom: 7px !important;}
.mb9{margin-bottom: 10px !important;}
.mlr40{margin-left: 40px !important; margin-right: 40px !important;}
.mlr30{margin-left: 30px !important; margin-right: 30px !important;}
.mb22{margin-bottom: 22px!important;}
.mb21{margin-bottom: 18px!important;}
.mb10{margin-bottom: 12px !important;}
.mb10a{margin-bottom: 11px !important;}
.mt10{margin-top: 11px !important;}
.mt13{margin-top: 18px !important;}
.mr20{margin-right: 20px !important;}
.pr6{padding-right: 2px !important;}
.tright{text-align: left!important;}
.w304{width: 339px !important;}
.pl56 {padding-left: 16px !important;}
.pr56 {padding-right: 59px !important;}
.w260 {width: 340px !important; min-width: 340px !important; max-width: 340px !important;}
.align{text-align: center !important;}
.pb{padding-bottom: 10px !important;}
.pdlr22{padding-left: 30px !important; padding-right: 30px !important;}
.pdlr15{padding-left: 15px !important; padding-right: 15px !important;}
.w280 {width: 98% !important;}
.mt42{margin-top: -42px !important;}
.bgmob{background-color: #ffffff!important;} 
.w320{width: 400px !important;} 
.w100 {width: 100%!important;}
.block3{display: block!important;}
.show {display: block!important;overflow: visible!important;float: none!important;width: 100%!important;height: auto!important;max-height: inherit!important;}
.block{display: block !important;}
.mlr22{margin-left: 4px !important; margin-right: 20px !important;}
.pb26{padding-bottom: 26px !important;}
.show1{display: block!important;}
.plr16{padding-left: 16px !important; padding-right: 22px !important;}
.display-footer {display: table-footer-group!important;width: 100%!important;min-width: 100%!important;}
.display-header {display: table-header-group!important;width: 50%!important;min-width: 100%!important;}
.drop {width: 100%!important;float: left!important;display: block!important;}
.nomob {display: none!important;width: 0px!important;height: 0px!important;}
div u + .body .gw10 { width: 178px !important;}
div u + .body .pt117 { padding-top: 240px !important;}
#menu-icon {
margin-right: 8% !important;padding-top: 0px!important;
} 
.button {
width: 100% !important;
}
.mt4{margin-top: 4px !important;}

#navigation-container { 
margin-right: 1% !important;
margin-left: 1% !important;
font-size: 12px !important;
} 

.interactivity-beacon:checked + table #menu-icon,
.interactivity-beacon:checked + table .menu-icon {
display: block !important;
mso-hide: none !important;
max-height: none !important;
overflow: visible !important;
}
/*.interactivity-beacon:checked + table .bgmob{background-color: 0px!important;}*/
.interactivity-beacon:checked + table .ptop{padding-top: 0px!important;}
#navigation-menu:checked + #menu-icon .icon-middle { 
-webkit-transform: scaleX(0); /* Android 4.4 */
transform: scaleX(0);
}
.interactivity-beacon:checked ~ table .navigation-second-row {
margin: 0px !important;
text-indent: initial !important;
}
#navigation-menu:checked + #menu-icon .menu-icon {
width: 24px !important;
background-color: #dddddd !important;
}

#navigation-menu:checked + #menu-icon .icon-top {
-webkit-transform: translateX(9px) rotate(45deg); /* Android 4.4 */
transform: translateX(9px) rotate(45deg); 
}

#navigation-menu:checked + #menu-icon .icon-bottom {
-webkit-transform: translateX(9px) rotate(-45deg); /* Android 4.4 */ 
transform: translateX(9px) rotate(-45deg); 
} 

.interactivity-beacon:checked + table #navigation-container { 
max-height: 0 !important; /* for accessibility */
overflow: hidden !important; /* for accessibility */
opacity: 0;
padding: 0 !important;
transition: max-height 0.3s ease, opacity 0.3s ease;
background-color: #deede3;
}
.interactivity-beacon:checked + table .pt24{padding-top: 22px !important;}
.interactivity-beacon:checked + table #navigation-container a {
display: block !important;
font-size: 14px !important;
line-height: 3 !important;
border-bottom: 1px solid #131212;
}

.interactivity-beacon:checked + table .nav-decoration {
display: none !important;
}

#navigation-menu:checked + label + #navigation-container {
max-height: 300px !important;
overflow: visible !important;
opacity: 1;
} 

#navigation-menu + label + #navigation-container:focus-within {
max-height: 300px !important;
overflow: visible !important;
opacity: 1;
} 
.bdr{border: none!important;}
}

/*Mobile CSS*/
@media only screen and (max-width: 410px){
.block3{display: none!important;}
.mright{margin-right: 0px !important;}
.h270{height:352px !important;}
.w30{width:30px !important;}
.lhight{line-height: 22px !important;}
.pb15{padding-bottom: 15px !important;}
.pt11{padding-top: 11px !important;}
.mb19{margin-bottom: 18px !important;}
.mb16{margin-bottom: 14px !important;}
.font13{font-size: 13px !important; line-height: 17px !important;}
.mb4{margin-bottom: 4px !important;}
.pb3{padding-bottom: 3px !important;}
.pb4{padding-bottom: 7px !important;}
.mb8{margin-bottom: 8px !important;}
.mt12{margin-top: 12px !important;}
.font16{font-size: 16px !important; line-height: 20px !important;}
.pt117{padding-top: 143px !important;}
.mt6{margin-top: 6px !important;}
.w240{width:232px !important;}
.pl15{padding-left: 30px !important;}
.pr15{padding-right: 30px !important;}
.mlr12{margin-left: 12px !important; margin-right: 12px !important;}
.pb14{padding-bottom: 14px !important;}
.mt15{margin-top: 11px !important;}
.mlr15{margin-left: 15px !important; margin-right: 15px !important;}
.pt10{padding-top: 12px !important;}
.pb10{padding-bottom: 12px !important;}
.pb12{padding-bottom: 19px !important;}
.w230{width:230px !important;}
.mr5{margin-right: 5px !important;}
.w12{width:12px !important;}
.ml12{margin-left: 12px !important;}
.mb37{margin-bottom: 37px !important;}
.w15{width:15px !important;}
.ml13{margin-left: 13px !important;}
.w17a{width:17px !important;}
.mt4{margin-top: 4px !important;}
.ml17{margin-left: 17px !important;}
.mr17{margin-right: 17px !important;}
.mb25{margin-bottom: 25px !important;}
.mb7{margin-bottom: 7px !important;}
.mb9{margin-bottom: 10px !important;}
.mlr40{margin-left: 40px !important; margin-right: 40px !important;}
.mlr30{margin-left: 30px !important; margin-right: 30px !important;}
.mb22{margin-bottom: 24px!important;}
.mb10a{margin-bottom: 11px !important;}
.mt10{margin-top: 11px !important;}
.mt10a{margin-top: 9px !important;}
.w260 {width: 260px !important; min-width: 260px !important; max-width: 260px !important;}
.pdlr22{padding-left: 30px !important; padding-right: 30px !important;}
.mlr22{margin-left: 4px !important; margin-right: 20px!important;}
.pb26{padding-bottom: 14px !important;}
.w320{width: 320px !important;}
.show1{display: block!important;}
.plr16{padding-left: 16px !important; padding-right: 20px !important;}
.w304{width: 262px !important;}
.pl56 {padding-left: 18px !important;}
.pr56 {padding-right: 59px !important;}
.block2{display: block !important;}
div u + .body .pt117 { padding-top: 115px !important;}
u + .body .fontt16 { font-size: 16px !important; line-height: 20px!important; }
}
</style>

<style>
u + .body .gmail-blend-screen { background:#000; mix-blend-mode:screen; }
u + .body .gmail-blend-difference { background:#000; mix-blend-mode:difference; }
@media (prefers-color-scheme: dark ) {
.mainbg { background-color: #000 !important; }
.bluebgcolor{background-color: #2f4644 !important;}
.greenbg { background-color: #30443f !important; }
.darkmode { background-color: #272623 !important; }
.white{background-color: #ffffff !important;}
h1, h2, p, span, a, b, ul, li, ol, h6, .mob { color: #ffffff !important; }
.darktext h1, .darktext h2, .darktext p, .darktext span, .darktext a{ color: #000 !important; }
.darktext1 h1, .darktext1 h2, .darktext1 p, .darktext1 span, .darktext1 a{ color: #ffffff !important; }
.textBlue{color: #223c83 !important;}
.textBlack{color: #000 !important;}
.bluebg{background-color: #add6d8 !important;}
.greytext{color: #000000 !important;}
.colwhite{color: #ffffff!important;}
.whitebCTA{border: 1px solid #fffff1 !important;}
/* OUTLOOK APP (ANDROID) DARK MODE STYLES */
[data-ogsc] .mainbg { background-color: #000 !important; }
[data-ogsc] .darkmode { background-color: #272623 !important; }
[data-ogsc] .white { background-color: #ffffff !important; }
[data-ogsc] h1, [data-ogsc] h2, [data-ogsc] h6, [data-ogsc] p, [data-ogsc] span, [data-ogsc] a, [data-ogsc] b, [data-ogsc] ul, [data-ogsc] li, [data-ogsc] ol { color: #ffffff !important; }
[data-ogsc] .darktext h1, [data-ogsc] .darktext h2, [data-ogsc] .darktext p, [data-ogsc] .darktext span, .darktext li{ color: #000 !important; }
[data-ogsc] .darktext1 h1, [data-ogsc] .darktext1 h2, [data-ogsc] .darktext1 p, [data-ogsc] .darktext1 span, .darktext1 li{ color: #000 !important; }
[data-ogsc].textBlue{color: #223c83 !important;}
[data-ogsc].textBlack{color: #000 !important;}
[data-ogsc].colwhite{color: #ffffff!important;}
[data-ogsc].bluebgcolor{color: #394645 !important;}
[data-ogsc].bluebg{background-color: #add6d8 !important;}
[data-ogsc].greenbg { background-color: #30443f !important; }
}
</style>

<style>
u + .body .colwhite{color: #ffffff!important;} 
u + .body .fnd{font-size: 16px !important; line-height: 20px !important;} 
</style>

<style>
@media screen and (-webkit-min-device-pixel-ratio: 0),
screen and (min-resolution: 72dpi) { 
.interactivity-beacon:checked ~ table .expandable-collapsible {
margin-bottom: 0 !important;
height: 0;
max-height: 0;
overflow: hidden; /* used instead of display none for transition and accessibility purposes */
transition: max-height 1s ease-in;
} 

.accordion:checked + table + .expandable-collapsible { 
height: auto;
max-height: 830px;
/* overflow: visible; removed due to transition causing suddenly and instantly visible copy to overlap */
transition: all 1s ease; 
}

.interactivity-beacon:checked + table label.openclose {
cursor: pointer;
display: block; 
background-image: url('https://ik.imagekit.io/sriHari143/templates/I1/open_-9MZuzWWHT.png?updatedAt=1742534063797');
background-size: 25px 25px;
min-height: 25px;
background-position: 100% 20%;
background-repeat: no-repeat; 
}
.interactivity-beacon:checked + table .Section_accordion .accordion:checked + table label { 
background-image: url('https://ik.imagekit.io/sriHari143/templates/I1/close_jMAoNkqUBF.png?updatedAt=1742534063577');
background-size: 26px 3px;
background-position: 100% 20%;
background-repeat: no-repeat; 
} 
/* Fallback for Mozilla Thunderbird, doesn&#39;t support checkboxes - spefically not able to toggle */
/* Fallback for AOL MAIL - understands webkit media, and attribute selectors but not not exact one */
.moz-text-html .interactivity-beacon:checked + table .expandable-collapsible, 
.interactivity-beacon:checked ~ table[class^="aolmail_container"] .expandable-collapsible {
height: auto;
max-height: none;
overflow: visible; 
} 
.moz-text-html .interactivity-beacon:checked + table label,
.moz-text-html .interactivity-beacon:checked ~ table .accordion:checked + table label, 
.interactivity-beacon:checked + table[class^="aolmail_container"] table label,
.interactivity-beacon:checked + table[class^="aolmail_container"] .accordion:checked + table label {
background: none; 
}
.interactivity-beacon:checked + table .accordion-ctrl{padding-right: 87px; padding-left: 31px;}
}
</style>

<meta name="GENERATOR" content="MSHTML 11.00.10570.1001"></head> 
<body class="body mainbg" style="margin: 0px; padding: 0px; background-color: rgb(232, 232, 232);">
<div id="preheader" style="color: rgb(227, 227, 227); line-height: 0; font-size: 0px; display: none; mso-hide: all;">Srihari Muppalla</div>
<div id="preview-spacer" style="color: rgb(227, 227, 227); line-height: 0; font-size: 0px; display: none; mso-hide: all;">͏  ͏ ͏ ͏͏ ͏ ͏ ͏ ͏ ͏͏ ͏ ͏ ͏ ͏ ͏͏ ͏ ͏ 
</div>
<div role="article" lang="en" style="font-size: 1rem;" dir="ltr" aria-label="email name" aria-roledescription="email">
<table width="100%" class="mainbg" role="presentation" bgcolor="#ffffff" border="0" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td align="center">
<div id="main">
<div id="inner"><!--[if !mso]><!--> <input class="interactivity-beacon" style="display: none; mso-hide: all;" type="checkbox" checked="checked"> <!--<![endif]--> 
<table width="600" class="w320 darkmode" role="presentation" style="width: 600px;" bgcolor="#ffffff" border="0" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td align="center" valign="top">
<table width="97%" class="w280" role="presentation" style="width: 97%;" border="0" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td align="center" valign="top">
<table width="560" class="w280" role="presentation" style="width: 560px;" border="0" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td align="center" style="padding-bottom: 2px; border-bottom-color: rgb(0, 0, 0); border-bottom-width: 1px; border-bottom-style: solid;">
<table width="100%" border="0" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td align="left" class="nomob" valign="top" style="text-align: left; color: rgb(0, 0, 0); line-height: 14px; padding-top: 10px; padding-bottom: 2px; font-family: Arial, Helvetica, sans-serif; font-size: 10px; font-weight: bold;">
<p style="margin: 0px;">Srihari Muppalla</p></td>
<td align="center" valign="top" style="font-family: Arial, Helvetica, sans-serif; text-align:center; font-size:14px; line-height: 18px; text-align: right; color: #000000; padding: 10px 0px 10px 0px;"><a href="https://srihari.site" target="_blank" style="font-family: Arial, Helvetica, sans-serif; font-weight: 400; color: #000000; font-size: 10px; line-height: 15px; text-decoration: none; text-transform: uppercase; display: inline;">View online</a></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table></td></tr>
<tr>
<td align="center" valign="top">
<table width="100%" role="presentation" border="0" cellspacing="0" cellpadding="0">
<tbody>
  <tr><td class="darkmode" style="padding: 20px 0px; font-size: 26px; line-height: 30px; font-family: Arial, Helvetica, sans-serif; text-align: center; font-weight: bold; color: #007BFF;">Srihari Muppalla</td></tr>
<tr>
<td align="center">
<table width="100%" class="w320" role="presentation" style="width: 100%;" border="0" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td align="center">
<table width="100%" class="darkmode" role="presentation" style="width: 100%; background-color: rgb(237, 244, 239);" bgcolor="#edf4ef" border="0" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td align="center" valign="top"><img width="600" height="auto" class="nomob" style="border: 0px currentColor; border-image: none; display: block;" alt="Sri" src="https://sriharim.in/Assets/normal/n3-banner.jpg"><!--[if !mso]><!--><span class="show" style="margin: 0px; overflow: hidden; display: none; max-height: 0px;"><img width="320" style="border: 0px currentColor; border-image: none; width: 100%; height: auto; display: block; max-width: 400px;" alt="Sri" src="https://sriharim.in/Assets/normal/n3-banner.jpg" border="0"></span><!--<![endif]--></td></tr></tbody></table></td></tr></tbody></table></td></tr>
<tr>
<td align="center" class="pb25">
<table width="520" class="w320" role="presentation" style="width: 520px;" border="0" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td align="left" class="pdlr22">
<p class="mt36" style="margin: 31px 0px 8px; text-align: left; color: rgb(0, 0, 0); line-height: 21px; font-family: Arial, Helvetica, sans-serif; font-size: 17px; font-weight: normal;"><strong>Dear User</strong></p>
<p class="mb22" style="margin: 0px 0px 24px; text-align: left; color: rgb(0, 0, 0); line-height: 22px; font-family: Arial, Helvetica, sans-serif; font-size: 17px; font-weight: normal;">Text 1 Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p></td></tr>
<tr>
<td align="center" class="pdlr22" style="padding-bottom: 10px;">
<table width="100%" class="mainbg" role="presentation" style="width: 100%; background-color: rgb(204, 221, 217);" bgcolor="#ccddd9" border="0" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td align="left">
<p class="mt10 mb10 malr30" style="margin: 8px 20px; text-align: left; color: rgb(0, 0, 0); line-height: 26px; font-family: Arial, Helvetica, sans-serif; font-size: 22px; font-weight: bold;">When will I start receiving digital <br class="nomob">only statements?</p></td></tr></tbody></table></td></tr>
<tr>
<td align="center" valign="top" style="padding-top: 20px; padding-bottom: 24px;">
<table width="100%" align="center" class="w260" border="0" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<th width="170" align="left" class="drop" valign="top" style="width: 170px; font-weight: normal;">
<p style="margin: 0px;"><img width="170" height="158" class="nomob" style="border: 0px currentColor; border-image: none; display: block;" alt="When will I start receiving digital only statements?" src="https://ik.imagekit.io/sriHari143/templates/I1/image1_DT_oNQFyTAkv.jpg?updatedAt=1742534062957"><!--[if !mso]><!--><span class="show" style="margin: 0px; overflow: hidden; display: none; max-height: 0px;"><img width="260" style="border: 0px currentColor; border-image: none; width: 100%; height: auto; display: block; max-width: 334px;" alt="When will I start receiving digital only statements?" src="https://ik.imagekit.io/sriHari143/templates/I1/image1_MB_USVsFXeVXQ.jpg?updatedAt=1742539773112" border="0"></span><!--<![endif]--></p></th>
<th width="26" align="center" class="drop nomob" style="width: 26px;">&nbsp;</th>
<th align="left" class="drop" valign="top" style="font-weight: normal;">
<p class="mb21 mt22" style="margin: 0px 0px 10px; text-align: left; color: rgb(0, 0, 0); line-height: 22px; font-family: Arial, Helvetica, sans-serif; font-size: 17px; font-weight: normal;">You don&#39;t have to do anything. We&#39;ve already changed your account settings, so when your next statement&#39;s due, it will be a digital one.</p>
<p style="margin: 0px; text-align: left; color: rgb(0, 0, 0); line-height: 22px; font-family: Arial, Helvetica, sans-serif; font-size: 17px; font-weight: normal;">You can already view, download or print out previous statements online, whenever you like.</p></th></tr></tbody></table></td></tr>
<tr>
<td class="pdlr22" style="padding-top: 0px; padding-bottom: 30px;">
<table width="100%" style="width: 100%; background-color: rgb(237, 239, 196);" bgcolor="#edefc4" border="0" cellspacing="0" cellpadding="0">
<tbody class="mainbg">
<tr>
<td align="center" style="padding-bottom: 24px;">
<table width="93%" class="w100" style="width: 93%;" border="0" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td align="left" class="plr15" valign="top">
<p style="margin: 16px 0px 0px; text-align: left; color: rgb(0, 0, 0); line-height: 26px; font-family: Arial, Helvetica, sans-serif; font-size: 22px; font-weight: bold;">How do I know when&nbsp;my digital <br class="nomob">statement is ready?</p>
<p style="margin: 14px 0px 18px; text-align: left; color: rgb(0, 0, 0); line-height: 21px; font-family: Arial, Helvetica, sans-serif; font-size: 17px; font-weight: normal;">We&#39;ll send you an email to this address each month to let you know your statement is ready to view. So please make sure we have an up-to-date email address for you.</p>
<p class="mb21" style="margin: 0px 0px 15px; text-align: left; color: rgb(0, 0, 0); line-height: 21px; font-family: Arial, Helvetica, sans-serif; font-size: 17px; font-weight: normal;">Visit our dedicated digital statements page for more information.</p>
<table width="172" align="left" class="w262 gw10" role="presentation" style="width: 172px; border-collapse: collapse; border-spacing: 0;" bgcolor="#005640" border="0" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td width="172" align="left" class="" style="border-width: 0px; width: 172px; height: 44px; text-align: center; color: rgb(255, 255, 255); padding-top: 0px; padding-bottom: 0px; font-family: Arial, Helvetica, sans-serif; font-weight: 400; text-decoration: none; vertical-align: middle; background-color: rgb(0, 86, 64);"><a title="Find out more" style="color: rgb(255, 255, 255); line-height: 256%; font-size: 18px; font-weight: normal; text-decoration: none;" href="https://srihari.site" target="_blank">Find out more</a></td>
</tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table></td></tr>
<tr>
<td class="pdlr22 pb16" style="padding-top: 0px; padding-bottom: 20px;">
<table width="100%" class="mainbg" style="width: 100%; background-color: rgb(204, 221, 217);" bgcolor="#ccddd9" border="0" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td align="center" style="padding-bottom: 24px;">
<table width="93%" class="w100" style="width: 93%;" border="0" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td align="left" class="plr15" valign="top">
<p style="margin: 16px 0px 0px; text-align: left; color: rgb(0, 0, 0); line-height: 26px; font-family: Arial, Helvetica, sans-serif; font-size: 22px; font-weight: bold;">Paying by Direct Debit is easy <br class="nomob">and&nbsp;convenient</p>
<p style="margin: 14px 0px 18px; text-align: left; color: rgb(0, 0, 0); line-height: 21px; font-family: Arial, Helvetica, sans-serif; font-size: 17px; font-weight: normal;">If you haven&#39;t already, it&#39;s worth considering setting up a Direct Debit to pay your Credit Card account automatically each month.</p>
<p class="mt10a" style="margin: 0px 0px 22px; text-align: left; color: rgb(0, 0, 0); line-height: 21px; font-family: Arial, Helvetica, sans-serif; font-size: 17px; font-weight: normal;">We have three different payment options you can choose from.* Visit our dedicated page to learn more and get started.</p>
<table width="100%" border="0" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<th width="200" align="left" class="drop" valign="top" style="width: 200px; font-weight: normal;">
<table width="152" align="left" class="w262 whitebCTA" role="presentation" style="width: 152px; border-collapse: collapse; border-spacing: 0;" bgcolor="#000000" border="0" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td width="152" align="left" style="border-width: 0px; width: 152px; height: 44px; text-align: center; color: rgb(255, 255, 255); padding-top: 0px; padding-bottom: 0px; font-family: Arial, Helvetica, sans-serif; font-weight: 400; text-decoration: none; vertical-align: middle; background-color: rgb(0, 0, 0);"><a title="Get started" style="color: rgb(255, 255, 255); line-height: 256%; font-size: 18px; font-weight: normal; text-decoration: none;" href="https://srihari.site" target="_blank">Get started</a></td></tr></tbody></table></th>
<th align="right" class="drop" valign="top"></th></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table></td></tr>
<tr>
<td>
<table width="100%" role="presentation" border="0" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td align="left">
<p class="mlr30" style="margin: 0px 0px 6px; text-align: left; color: rgb(0, 0, 0); line-height: 21px; font-family: Arial, Helvetica, sans-serif; font-size: 17px; font-weight: normal;">We hope this helps make managing your account easier. <br>Thank you for choosing  Bank.</p>
<p class="mlr30" style="margin: 0px 0px 25px; text-align: left; color: rgb(0, 0, 0); line-height: 21px; font-family: Arial, Helvetica, sans-serif; font-size: 17px; font-weight: bold;">Your  Bank Team</p></td></tr></tbody></table></td></tr>
<tr>
<td class="pdlr22" style="padding-bottom: 15px;">
<table width="100%" style="width: 100%; background-color: rgb(153, 187, 179);" bgcolor="#99bbb3" border="0" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td align="center">
<p class="mt10a mlr15 " style="margin: 8px 20px 6px; text-align: left; color: rgb(0, 0, 0); line-height: 26px; font-family: Arial, Helvetica, sans-serif; font-size: 22px; font-weight: bold;">Helpful information</p></td></tr></tbody></table></td></tr>
<tr>
<td align="center" valign="top">
<table width="100%" align="center" class="w304" role="presentation" style="width: 100%;" border="0" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td align="center" valign="top">
<div class="Section_accordion"><!--[if !mso]><!--> 
<input class="accordion" id="accor1" style="display: none;" type="checkbox"> <!--<![endif]--> 
<table width="100%" class="accordion_table" border="0" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td align="left" class="plr16" valign="top" style="padding: 14px 20px; text-align: left; color: rgb(0, 0, 0); line-height: 22px; font-family: Arial, Helvetica, sans-serif; font-size: 17px; font-weight: bold;" bgcolor="#b0c7c0"><label class="openclose" for="accor1">I don&#39;t have a printer <span class="block2"></span>and need a copy of a&nbsp;statement</label></td></tr></tbody></table>
<div class="expandable-collapsible">
<table width="100%" border="0" cellspacing="0" cellpdding="0">
<tbody>
<tr>
<td align="center" class="plr16" valign="top" style="padding-right: 20px; padding-bottom: 8px; padding-left: 20px;">
<p class="mt13" style="margin: 18px 0px 0px; padding: 0px; text-align: left; color: rgb(0, 0, 0); line-height: 22px; font-family: Arial, Helvetica, sans-serif; font-size: 17px;">You are still able to request paper statement copies if required. The easiest way to get in touch is via Chat in the  Banking App or Internet Banking.</p></td></tr></tbody></table></div></div></td></tr></tbody></table>
<p class="mb8" style="margin: 0px 0px 15px; padding: 0px; line-height: 1px; font-size: 1px;">&nbsp;</p>
<table width="100%" align="center" class="w304" role="presentation" style="width: 100%;" border="0" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td align="center" valign="top">
<div class="Section_accordion"><!--[if !mso]><!--> 
<input class="accordion" id="accor2" style="display: none;" type="checkbox"> <!--<![endif]--> 
<table width="100%" class="accordion_table" border="0" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td align="left" class="plr16" valign="top" style="padding: 14px 20px; text-align: left; color: rgb(0, 0, 0); line-height: 22px; font-family: Arial, Helvetica, sans-serif; font-size: 17px; font-weight: bold;" bgcolor="#b0c7c0"><label class="openclose" for="accor2">I want to <span class="block2"></span>continue receiving <span class="block3"></span>paper <span class="block2"></span>statements 
</label></td></tr></tbody></table>
<div class="expandable-collapsible">
<table width="100%" border="0" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td align="center" class="plr16" valign="top" style="padding-right: 20px; padding-bottom: 5px; padding-left: 20px;">
<p class="mt13" style="margin: 18px 0px 17px; padding: 0px; text-align: left; color: rgb(0, 0, 0); line-height: 22px; font-family: Arial, Helvetica, sans-serif; font-size: 17px;">If you would prefer to continue receiving your statements through the post you can revert back to paper statements at any time by following the steps below:</p>
<p style="margin: 0px; padding: 0px; text-align: left; color: rgb(0, 0, 0); line-height: 22px; font-family: Arial, Helvetica, sans-serif; font-size: 17px;"><strong>In the app:</strong><br> Tap the profile icon in the top right-hand corner of the &#39;Balances&#39; screen, select &#39;Communication preferences&#39;, select &#39;Statement preferences&#39;, then &#39;Statements&#39; and then toggle &#39;Paper statements&#39; to &#39;on&#39; and choose the accounts which you&#39;d like to receive paper statements for.</p>
<p class="mt13" style="margin: 20px 0px 0px; padding: 0px; text-align: left; color: rgb(0, 0, 0); line-height: 22px; font-family: Arial, Helvetica, sans-serif; font-size: 17px;"><strong>Via Chat: </strong><br> Start a conversation in Chat asking &#34;Help with statements&#34;, select &#34;Change my statement delivery preference&#34; then follow the prompts. <br><br>Alternatively, you can call us on <a title="Call" style="color: rgb(0, 0, 0); text-decoration: none;" href="tel:03456005860" target="_blank">0345&nbsp;600&nbsp;5860</a>.</p></td></tr></tbody></table></div></div></td></tr></tbody></table>
<p class="mb8" style="margin: 0px 0px 15px; padding: 0px; line-height: 1px; font-size: 1px;">&nbsp;</p>
<table width="100%" align="center" class="w304" role="presentation" style="width: 100%;" border="0" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td align="center" valign="top">
<div class="Section_accordion"><!--[if !mso]><!--> 
<input class="accordion" id="accor3" style="display: none;" type="checkbox"> <!--<![endif]--> 
<table width="100%" class="accordion_table" border="0" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td align="left" class="plr16" valign="top" style="padding: 14px 20px; text-align: left; color: rgb(0, 0, 0); line-height: 22px; font-family: Arial, Helvetica, sans-serif; font-size: 17px; font-weight: bold;" bgcolor="#b0c7c0"><label class="openclose" for="accor3">How do I update my <span class="block3"></span>email&nbsp;address?</label></td></tr></tbody></table>
<div class="expandable-collapsible">
<table width="100%" border="0" cellspacing="0" 
cellpadding="0">
<tbody>
<tr>
<td align="center" class="plr16" valign="top" style="padding-right: 20px; padding-bottom: 5px; padding-left: 20px;">
<p class="mt13" style="margin: 18px 0px 9px; padding: 0px; text-align: left; color: rgb(0, 0, 0); line-height: 22px; font-family: Arial, Helvetica, sans-serif; font-size: 17px;">If you need to, you can update your email address and other contact details in our app or Internet Banking.</p>
<p class="mt13" style="margin: 7px 0px 0px; padding: 0px; text-align: left; color: rgb(0, 0, 0); line-height: 22px; font-family: Arial, Helvetica, sans-serif; font-size: 17px;">Visit our <a title="contact details page" style="color: rgb(0, 0, 0); text-decoration: underline;" href="https://srihari.site" target="_blank">contact details page</a> for more information on how to update your details.</p></td></tr></tbody></table></div></div></td></tr></tbody></table></td></tr>
<tr>
<td align="left" valign="top">
<table width="85%" align="center" class="w100" role="presentation" style="width: 85%;" border="0" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td align="left" class="plr24" valign="top" style="padding-top: 0px;">
<p style="margin: 24px 0px 0px; text-align: center; color: rgb(0, 0, 0); line-height: 18px; font-family: Arial, Helvetica, sans-serif; font-size: 14px; font-weight: normal;"><strong>This is a service email from &nbsp;Bank.</strong></p></td></tr>
<tr>
<td height="28" class="h12" style="height: 28px; line-height: 1px; font-size: 1px;">&nbsp;</td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table></td></tr>
</tbody></table></div></div></td></tr></tbody></table></div></body></html>
`;